import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {catalogTransactions} from '../../../common/dictionaries/parameters';

class Header extends Component {
  changeListOrigin(origin) {
    this.props.selectPartsListOrigin(origin);
    this.props.getTransactionStatus(catalogTransactions[origin].transaction);
  }
  
  renderSelector() {
    const {listOrigin, loadingFile, loadingStatus} = this.props;

    return (
      <Button.Group>
        <Button
          primary={listOrigin === 'japan'}
          onClick={() => this.changeListOrigin('japan')}
          disabled={loadingFile || loadingStatus}
        >JAPÓN</Button>
        <Button.Or text='O' />
        <Button
          primary={listOrigin === 'others'}
          onClick={() => this.changeListOrigin('others')}
          disabled={loadingFile || loadingStatus}
        >
          ARGENTINA / BRASIL
        </Button>
      </Button.Group>
    );
  }

  render() {
    return (
      <Card raised fluid className='header'>
        <Grid>
          <Grid.Row>
            <Grid.Column width='8' textAlign='left'>
              <h2>Carga de Archivo JPML</h2>
            </Grid.Column>
            <Grid.Column width='8' textAlign='right'>
              {this.renderSelector()}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'listOrigin': state.partsCatalog.listOrigin,
    'loadingFile': state.partsCatalog.loadingFile,
    'loadingStatus': state.partsCatalog.loadingStatus,
  };
};

const {selectPartsListOrigin, getTransactionStatus} = Actions;

export default connect(mapStateToProps, {selectPartsListOrigin, getTransactionStatus})(Header);
